// Loading skeleton for vitals
const VitalsSkeleton = () => (
  <div className="animate-pulse space-y-4 qhd:space-y-6 4k:space-y-8">
    <div className="h-24 qhd:h-28 4k:h-32 bg-gray-200 dark:bg-gray-700 rounded-2xl qhd:rounded-3xl" />
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 qhd:gap-4 4k:gap-6">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="h-16 qhd:h-20 4k:h-24 bg-gray-200 dark:bg-gray-700 rounded-xl qhd:rounded-2xl" />
      ))}
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 qhd:gap-6 4k:gap-8">
      <div className="h-48 qhd:h-56 4k:h-64 bg-gray-200 dark:bg-gray-700 rounded-2xl qhd:rounded-3xl" />
      <div className="h-48 qhd:h-56 4k:h-64 bg-gray-200 dark:bg-gray-700 rounded-2xl qhd:rounded-3xl" />
    </div>
    <div className="h-40 qhd:h-48 4k:h-56 bg-gray-200 dark:bg-gray-700 rounded-2xl qhd:rounded-3xl" />
  </div>
);

export default VitalsSkeleton;
